import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-grid-cars__img-wrap"
}
const _hoisted_2 = {
  key: 0,
  class: "c-grid-cars__econoplus"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "c-grid-cars__info-inner" }
const _hoisted_6 = { class: "c-grid-cars__info-regular" }
const _hoisted_7 = { class: "c-grid-cars__info-inner" }
const _hoisted_8 = { class: "c-grid-cars__info-regular" }
const _hoisted_9 = {
  key: 2,
  class: "c-grid-cars-big"
}
const _hoisted_10 = { class: "c-grid-cars-big__left" }
const _hoisted_11 = { class: "c-grid-cars__img-wrap" }
const _hoisted_12 = {
  key: 0,
  class: "c-grid-cars__econoplus"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "c-grid-cars__info" }
const _hoisted_16 = { class: "c-grid-cars__info-inner" }
const _hoisted_17 = { class: "c-grid-cars__info-strong" }
const _hoisted_18 = { class: "c-grid-cars__info-regular" }
const _hoisted_19 = { class: "c-grid-cars-big__content -left" }
const _hoisted_20 = { class: "c-grid-cars__title" }
const _hoisted_21 = { class: "c-grid-cars__row" }
const _hoisted_22 = { class: "c-grid-cars__trim" }
const _hoisted_23 = { class: "c-grid-cars__km" }
const _hoisted_24 = { class: "c-grid-cars-big__reserve" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "c-grid-cars__niv" }
const _hoisted_27 = { class: "c-grid-cars-big__right" }
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "c-grid-cars__row" }
const _hoisted_30 = { class: "c-grid-cars__col" }
const _hoisted_31 = { class: "o-h3" }
const _hoisted_32 = { class: "c-grid-cars__col" }
const _hoisted_33 = { class: "c-grid-cars__col -bottom" }
const _hoisted_34 = { class: "c-grid-cars-big__prices" }
const _hoisted_35 = { class: "c-grid-cars-big__prices__item" }
const _hoisted_36 = { class: "c-grid-cars__payment-time" }
const _hoisted_37 = { class: "c-grid-cars__payment-amount" }
const _hoisted_38 = { class: "c-grid-cars__payment-amount__num" }
const _hoisted_39 = { class: "c-grid-cars-big__prices__item" }
const _hoisted_40 = { class: "c-grid-cars__price-old -stroke" }
const _hoisted_41 = { class: "c-grid-cars__payment-amount" }
const _hoisted_42 = { class: "c-grid-cars__payment-amount__num" }
const _hoisted_43 = ["href"]
const _hoisted_44 = { class: "c-grid-cars__title" }
const _hoisted_45 = { class: "c-grid-cars__trim" }
const _hoisted_46 = { class: "c-grid-cars__km" }
const _hoisted_47 = {
  key: 0,
  class: "c-grid-cars__payment"
}
const _hoisted_48 = { class: "c-grid-cars__payment-time -grid-cars-color-alt" }
const _hoisted_49 = { class: "c-grid-cars__payment-amount" }
const _hoisted_50 = { class: "c-grid-cars__payment-amount__num" }
const _hoisted_51 = { class: "c-grid-cars__price" }
const _hoisted_52 = { class: "c-grid-cars__price-wrap" }
const _hoisted_53 = {
  key: 0,
  class: "c-grid-cars__price-old -stroke"
}
const _hoisted_54 = { class: "c-grid-cars__price-new" }
const _hoisted_55 = {
  key: 0,
  class: "c-grid-cars__price-tag"
}
const _hoisted_56 = { class: "c-grid-cars__niv" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svgIco = _resolveComponent("svgIco")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-grid-cars__item", { '-large': $props.type === 'big', '-new': $props.car.inventory == 'new' }])
  }, [
    ($props.type=='small')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          ($props.car.kms >= 130000 || $props.car.year <= 2016)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _cache[0] || (_cache[0] = [
                _createElementVNode("svg", {
                  width: "44",
                  height: "10",
                  viewBox: "0 0 44 10",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M0.920478 2.0028H5.65388V3.0808H2.21408V4.8742H5.45788V5.962H2.21408V7.922H5.84988L5.69308 9H0.920478V2.0028ZM3.72328 0.0133993H5.18348L3.73308 1.4246H2.53748L3.72328 0.0133993ZM7.05941 3.5218C7.33381 2.973 7.71275 2.55487 8.19621 2.2674C8.68621 1.9734 9.24808 1.8264 9.88181 1.8264C10.4633 1.8264 10.9467 1.9244 11.3322 2.1204C11.7177 2.30987 12.0215 2.581 12.2436 2.9338C12.4723 3.2866 12.6323 3.70473 12.7238 4.1882L11.44 4.3646C11.3355 3.92033 11.1656 3.57407 10.9304 3.3258C10.7017 3.07753 10.3457 2.9534 9.86221 2.9534C9.26768 2.9534 8.81035 3.18207 8.49021 3.6394C8.17661 4.09673 8.01981 4.71413 8.01981 5.4916C8.01981 6.28213 8.17988 6.90607 8.50001 7.3634C8.82015 7.82073 9.28075 8.0494 9.88181 8.0494C10.411 8.0494 10.7965 7.91547 11.0382 7.6476C11.2799 7.3732 11.4335 7.01713 11.4988 6.5794H12.8316C12.7859 7.089 12.6421 7.5398 12.4004 7.9318C12.1652 8.3238 11.8353 8.63087 11.4106 8.853C10.9925 9.0686 10.4763 9.1764 9.86221 9.1764C9.19581 9.1764 8.62088 9.03267 8.13741 8.7452C7.66048 8.45773 7.29135 8.04287 7.03001 7.5006C6.77521 6.95833 6.64781 6.30173 6.64781 5.5308C6.64781 4.74027 6.78501 4.0706 7.05941 3.5218ZM14.1032 3.5218C14.3841 2.96647 14.7728 2.54507 15.2694 2.2576C15.7659 1.97013 16.3474 1.8264 17.0138 1.8264C17.6867 1.8264 18.2682 1.97013 18.7582 2.2576C19.2547 2.53853 19.6369 2.95013 19.9048 3.4924C20.1792 4.03467 20.3164 4.69453 20.3164 5.472C20.3164 6.256 20.1792 6.92567 19.9048 7.481C19.6369 8.0298 19.2547 8.4512 18.7582 8.7452C18.2616 9.03267 17.6736 9.1764 16.9942 9.1764C16.3278 9.1764 15.7463 9.03593 15.2498 8.755C14.7532 8.46753 14.3678 8.05267 14.0934 7.5104C13.8255 6.96813 13.6916 6.305 13.6916 5.521C13.6916 4.737 13.8288 4.0706 14.1032 3.5218ZM17.004 2.9534C16.3506 2.9534 15.8606 3.18207 15.534 3.6394C15.2073 4.09673 15.044 4.7174 15.044 5.5014C15.044 6.29193 15.2073 6.91587 15.534 7.3732C15.8606 7.824 16.3506 8.0494 17.004 8.0494C17.6442 8.0494 18.1277 7.824 18.4544 7.3732C18.7876 6.91587 18.9542 6.29193 18.9542 5.5014C18.9542 4.7174 18.7876 4.09673 18.4544 3.6394C18.1277 3.18207 17.6442 2.9534 17.004 2.9534ZM21.5254 2.0028H22.7308L25.8864 6.9518V2.0028H27.1212V9H25.9452L22.77 4.0804V9H21.5254V2.0028ZM28.7457 3.5218C29.0267 2.96647 29.4154 2.54507 29.9119 2.2576C30.4085 1.97013 30.9899 1.8264 31.6563 1.8264C32.3293 1.8264 32.9107 1.97013 33.4007 2.2576C33.8973 2.53853 34.2795 2.95013 34.5473 3.4924C34.8217 4.03467 34.9589 4.69453 34.9589 5.472C34.9589 6.256 34.8217 6.92567 34.5473 7.481C34.2795 8.0298 33.8973 8.4512 33.4007 8.7452C32.9042 9.03267 32.3162 9.1764 31.6367 9.1764C30.9703 9.1764 30.3889 9.03593 29.8923 8.755C29.3958 8.46753 29.0103 8.05267 28.7359 7.5104C28.4681 6.96813 28.3341 6.305 28.3341 5.521C28.3341 4.737 28.4713 4.0706 28.7457 3.5218ZM31.6465 2.9534C30.9932 2.9534 30.5032 3.18207 30.1765 3.6394C29.8499 4.09673 29.6865 4.7174 29.6865 5.5014C29.6865 6.29193 29.8499 6.91587 30.1765 7.3732C30.5032 7.824 30.9932 8.0494 31.6465 8.0494C32.2868 8.0494 32.7703 7.824 33.0969 7.3732C33.4301 6.91587 33.5967 6.29193 33.5967 5.5014C33.5967 4.7174 33.4301 4.09673 33.0969 3.6394C32.7703 3.18207 32.2868 2.9534 31.6465 2.9534Z",
                    fill: "white"
                  }),
                  _createElementVNode("path", {
                    d: "M43.0451 4.4752H40.6351V2.0752H38.6051V4.4752C37.9551 4.4752 37.0751 4.4752 36.2051 4.4752V6.5152C36.9151 6.5152 37.8851 6.5152 38.6051 6.5152C38.6051 7.1652 38.6051 8.0452 38.6051 8.9252H40.6451C40.6451 8.2152 40.6451 7.2452 40.6451 6.5152H43.0551V4.4852L43.0451 4.4752Z",
                    fill: "#EA001D"
                  })
                ], -1 /* HOISTED */)
              ])))
            : _createCommentVNode("v-if", true),
          _createElementVNode("a", {
            href: $props.car.permalink
          }, [
            _createElementVNode("img", {
              class: "c-grid-cars__img",
              src: $props.car.photo,
              alt: $props.car.title
            }, null, 8 /* PROPS */, _hoisted_4)
          ], 8 /* PROPS */, _hoisted_3)
        ]))
      : _createCommentVNode("v-if", true),
    ($props.type=='small' && $props.car.payments?.certified)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["c-grid-cars__info", {'-alt': !$props.car.is_certified}])
        }, [
          ($props.car.is_certified)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[2] || (_cache[2] = _createElementVNode("svg", {
                  class: "c-grid-cars__info-icon",
                  width: "21",
                  height: "25",
                  viewBox: "0 0 21 25",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    class: "c-grid-cars__info-icon-path-1",
                    d: "M19.917 3.9493L10.8007 0.574297C10.6322 0.514297 10.433 0.514297 10.2645 0.574297L1.13287 3.9493C0.841757 4.0543 0.642578 4.3393 0.642578 4.6543V12.5293C0.642578 19.6543 9.7895 24.2593 10.1879 24.4543C10.2951 24.5143 10.4177 24.5293 10.5249 24.5293C10.6322 24.5293 10.7548 24.4993 10.862 24.4543C11.245 24.2593 20.4073 19.6693 20.4073 12.5293V4.6543C20.4073 4.3393 20.2081 4.0693 19.917 3.9493Z",
                    fill: "#2CA342"
                  }),
                  _createElementVNode("path", {
                    class: "c-grid-cars__info-icon-path-2",
                    d: "M9.62424 15.6547L16.6504 7.90393L15.4043 6.5293L8.37812 14.28L5.64651 11.259L4.40039 12.6336L7.132 15.6547L8.37108 17.0138L8.38516 17.0293L8.43444 16.9672L9.62424 15.6547Z",
                    fill: "white"
                  })
                ], -1 /* HOISTED */)),
                _createElementVNode("div", _hoisted_5, [
                  _cache[1] || (_cache[1] = _createElementVNode("strong", { class: "c-grid-cars__info-strong" }, "Véhicule d’occasion certifié", -1 /* HOISTED */)),
                  _createElementVNode("span", _hoisted_6, "Taux à partir de " + _toDisplayString(_ctx.pct($props.car.payments.percent)), 1 /* TEXT */)
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          (!$props.car.is_certified)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[4] || (_cache[4] = _createElementVNode("svg", {
                  class: "c-grid-cars__info-icon",
                  width: "20",
                  height: "25",
                  viewBox: "0 0 20 25",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    class: "c-grid-cars__info-icon-path-1",
                    d: "M1.14258 12.5293V4.82429L9.9214 1.5428L18.6852 4.82418V12.5293C18.6852 15.6676 16.684 18.3487 14.4422 20.3502C12.4635 22.1169 10.4426 23.223 9.9129 23.5012C9.40521 23.2368 7.37073 22.1252 5.38053 20.3452C3.14032 18.3416 1.14258 15.6604 1.14258 12.5293Z",
                    fill: "#E6EAEB",
                    stroke: "#2F4858",
                    "stroke-width": "2"
                  }),
                  _createElementVNode("path", {
                    class: "c-grid-cars__info-icon-path-2",
                    d: "M9.01574 15.6547L15.9629 7.90393L14.7308 6.5293L7.78362 14.28L5.08271 11.259L3.85059 12.6336L6.5515 15.6547L7.77666 17.0138L7.79058 17.0293L7.83931 16.9672L9.01574 15.6547Z",
                    fill: "#2F4858"
                  })
                ], -1 /* HOISTED */)),
                _createElementVNode("div", _hoisted_7, [
                  _cache[3] || (_cache[3] = _createElementVNode("strong", { class: "c-grid-cars__info-strong" }, "Certification disponible", -1 /* HOISTED */)),
                  _createElementVNode("span", _hoisted_8, "Taux à partir de " + _toDisplayString(_ctx.pct($props.car.payments.best_percent)), 1 /* TEXT */)
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    ($props.type=='big')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              ($props.car.kms >= 130000 || $props.car.year <= 2016)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _cache[5] || (_cache[5] = [
                    _createElementVNode("svg", {
                      width: "44",
                      height: "10",
                      viewBox: "0 0 44 10",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M0.920478 2.0028H5.65388V3.0808H2.21408V4.8742H5.45788V5.962H2.21408V7.922H5.84988L5.69308 9H0.920478V2.0028ZM3.72328 0.0133993H5.18348L3.73308 1.4246H2.53748L3.72328 0.0133993ZM7.05941 3.5218C7.33381 2.973 7.71275 2.55487 8.19621 2.2674C8.68621 1.9734 9.24808 1.8264 9.88181 1.8264C10.4633 1.8264 10.9467 1.9244 11.3322 2.1204C11.7177 2.30987 12.0215 2.581 12.2436 2.9338C12.4723 3.2866 12.6323 3.70473 12.7238 4.1882L11.44 4.3646C11.3355 3.92033 11.1656 3.57407 10.9304 3.3258C10.7017 3.07753 10.3457 2.9534 9.86221 2.9534C9.26768 2.9534 8.81035 3.18207 8.49021 3.6394C8.17661 4.09673 8.01981 4.71413 8.01981 5.4916C8.01981 6.28213 8.17988 6.90607 8.50001 7.3634C8.82015 7.82073 9.28075 8.0494 9.88181 8.0494C10.411 8.0494 10.7965 7.91547 11.0382 7.6476C11.2799 7.3732 11.4335 7.01713 11.4988 6.5794H12.8316C12.7859 7.089 12.6421 7.5398 12.4004 7.9318C12.1652 8.3238 11.8353 8.63087 11.4106 8.853C10.9925 9.0686 10.4763 9.1764 9.86221 9.1764C9.19581 9.1764 8.62088 9.03267 8.13741 8.7452C7.66048 8.45773 7.29135 8.04287 7.03001 7.5006C6.77521 6.95833 6.64781 6.30173 6.64781 5.5308C6.64781 4.74027 6.78501 4.0706 7.05941 3.5218ZM14.1032 3.5218C14.3841 2.96647 14.7728 2.54507 15.2694 2.2576C15.7659 1.97013 16.3474 1.8264 17.0138 1.8264C17.6867 1.8264 18.2682 1.97013 18.7582 2.2576C19.2547 2.53853 19.6369 2.95013 19.9048 3.4924C20.1792 4.03467 20.3164 4.69453 20.3164 5.472C20.3164 6.256 20.1792 6.92567 19.9048 7.481C19.6369 8.0298 19.2547 8.4512 18.7582 8.7452C18.2616 9.03267 17.6736 9.1764 16.9942 9.1764C16.3278 9.1764 15.7463 9.03593 15.2498 8.755C14.7532 8.46753 14.3678 8.05267 14.0934 7.5104C13.8255 6.96813 13.6916 6.305 13.6916 5.521C13.6916 4.737 13.8288 4.0706 14.1032 3.5218ZM17.004 2.9534C16.3506 2.9534 15.8606 3.18207 15.534 3.6394C15.2073 4.09673 15.044 4.7174 15.044 5.5014C15.044 6.29193 15.2073 6.91587 15.534 7.3732C15.8606 7.824 16.3506 8.0494 17.004 8.0494C17.6442 8.0494 18.1277 7.824 18.4544 7.3732C18.7876 6.91587 18.9542 6.29193 18.9542 5.5014C18.9542 4.7174 18.7876 4.09673 18.4544 3.6394C18.1277 3.18207 17.6442 2.9534 17.004 2.9534ZM21.5254 2.0028H22.7308L25.8864 6.9518V2.0028H27.1212V9H25.9452L22.77 4.0804V9H21.5254V2.0028ZM28.7457 3.5218C29.0267 2.96647 29.4154 2.54507 29.9119 2.2576C30.4085 1.97013 30.9899 1.8264 31.6563 1.8264C32.3293 1.8264 32.9107 1.97013 33.4007 2.2576C33.8973 2.53853 34.2795 2.95013 34.5473 3.4924C34.8217 4.03467 34.9589 4.69453 34.9589 5.472C34.9589 6.256 34.8217 6.92567 34.5473 7.481C34.2795 8.0298 33.8973 8.4512 33.4007 8.7452C32.9042 9.03267 32.3162 9.1764 31.6367 9.1764C30.9703 9.1764 30.3889 9.03593 29.8923 8.755C29.3958 8.46753 29.0103 8.05267 28.7359 7.5104C28.4681 6.96813 28.3341 6.305 28.3341 5.521C28.3341 4.737 28.4713 4.0706 28.7457 3.5218ZM31.6465 2.9534C30.9932 2.9534 30.5032 3.18207 30.1765 3.6394C29.8499 4.09673 29.6865 4.7174 29.6865 5.5014C29.6865 6.29193 29.8499 6.91587 30.1765 7.3732C30.5032 7.824 30.9932 8.0494 31.6465 8.0494C32.2868 8.0494 32.7703 7.824 33.0969 7.3732C33.4301 6.91587 33.5967 6.29193 33.5967 5.5014C33.5967 4.7174 33.4301 4.09673 33.0969 3.6394C32.7703 3.18207 32.2868 2.9534 31.6465 2.9534Z",
                        fill: "white"
                      }),
                      _createElementVNode("path", {
                        d: "M43.0451 4.4752H40.6351V2.0752H38.6051V4.4752C37.9551 4.4752 37.0751 4.4752 36.2051 4.4752V6.5152C36.9151 6.5152 37.8851 6.5152 38.6051 6.5152C38.6051 7.1652 38.6051 8.0452 38.6051 8.9252H40.6451C40.6451 8.2152 40.6451 7.2452 40.6451 6.5152H43.0551V4.4852L43.0451 4.4752Z",
                        fill: "#EA001D"
                      })
                    ], -1 /* HOISTED */)
                  ])))
                : _createCommentVNode("v-if", true),
              _createElementVNode("a", {
                href: $props.car.permalink
              }, [
                _createElementVNode("img", {
                  class: "c-grid-cars__img",
                  src: $props.car.photo,
                  alt: $props.car.title
                }, null, 8 /* PROPS */, _hoisted_14)
              ], 8 /* PROPS */, _hoisted_13)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[6] || (_cache[6] = _createElementVNode("svg", {
                class: "c-grid-cars__info-icon",
                width: "21",
                height: "25",
                viewBox: "0 0 21 25",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  class: "c-grid-cars__info-icon-path-1",
                  d: "M19.917 3.9493L10.8007 0.574297C10.6322 0.514297 10.433 0.514297 10.2645 0.574297L1.13287 3.9493C0.841757 4.0543 0.642578 4.3393 0.642578 4.6543V12.5293C0.642578 19.6543 9.7895 24.2593 10.1879 24.4543C10.2951 24.5143 10.4177 24.5293 10.5249 24.5293C10.6322 24.5293 10.7548 24.4993 10.862 24.4543C11.245 24.2593 20.4073 19.6693 20.4073 12.5293V4.6543C20.4073 4.3393 20.2081 4.0693 19.917 3.9493Z",
                  fill: "#2CA342"
                }),
                _createElementVNode("path", {
                  class: "c-grid-cars__info-icon-path-2",
                  d: "M9.62424 15.6547L16.6504 7.90393L15.4043 6.5293L8.37812 14.28L5.64651 11.259L4.40039 12.6336L7.132 15.6547L8.37108 17.0138L8.38516 17.0293L8.43444 16.9672L9.62424 15.6547Z",
                  fill: "white"
                })
              ], -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("strong", _hoisted_17, _toDisplayString($props.car.is_certified ? 'Véhicule d’occasion certifié' : 'Certification disponible'), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_18, "Taux à partir de " + _toDisplayString(_ctx.pct($props.car.payments.best_percent)), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h3", _hoisted_20, _toDisplayString($props.car.make) + " " + _toDisplayString($props.car.model), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, _toDisplayString($props.car.trim) + " " + _toDisplayString($props.car.year), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.nb($props.car.kms)) + " km ", 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "c-grid-cars-big__reserve__title" }, "Faites vite!", -1 /* HOISTED */)),
                _createElementVNode("a", {
                  href: $props.car.permalink,
                  class: "o-button -outline"
                }, [
                  _cache[7] || (_cache[7] = _createTextVNode(" Réserver ce véhicule ")),
                  _createVNode(_component_svgIco, { icon: "arrow-right" })
                ], 8 /* PROPS */, _hoisted_25)
              ]),
              _createElementVNode("div", _hoisted_26, " Stock " + _toDisplayString($props.car.stocknumber) + " / NIV " + _toDisplayString($props.car.vin_short), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("a", {
              href: $props.car.permalink,
              class: "c-grid-cars-big__content"
            }, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_svgIco, { icon: "arrow-desc" }),
                  _createElementVNode("div", _hoisted_31, [
                    _cache[9] || (_cache[9] = _createTextVNode(" Baisse de prix ")),
                    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                    _createElementVNode("strong", null, "-" + _toDisplayString(_ctx.cash($props.car.rebate)), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_svgIco, { icon: "clock-2025-fast" }),
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "o-h3" }, [
                    _createTextVNode(" Livraison rapide "),
                    _createElementVNode("br"),
                    _createElementVNode("strong", null, "en stock")
                  ], -1 /* HOISTED */))
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createCommentVNode(" <div class=\"c-grid-cars__payment-time\">Financement {{car.payments.term}} mois</div> "),
                      _createElementVNode("div", _hoisted_36, _toDisplayString($props.car.payments.type=='lease' ? 'Location' : 'Financement') + " à partir de", 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, [
                          _createTextVNode(_toDisplayString(_ctx.cents($props.car.payments.weekly)) + " ", 1 /* TEXT */),
                          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "c-grid-cars__payment-amount__small" }, " /sem", -1 /* HOISTED */))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.cash($props.car.price+$props.car.rebate)), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.cash($props.car.price)), 1 /* TEXT */)
                      ])
                    ]),
                    _createCommentVNode(" À coder \n                                <div class=\"c-grid-cars-big__prices__item\">\n                                    <div class=\"c-grid-cars__payment-time\">{{ car.payments.type=='lease' ? 'Location' : 'Financement' }} à partir de</div>\n                                    <div class=\"c-grid-cars__payment-amount\">\n                                        <span class=\"c-grid-cars__payment-amount__num\">{{cents(car.payments.weekly)}}\n                                            <span class=\"c-grid-cars__payment-amount__small\"> /sem</span>\n                                        </span>\n                                    </div>\n                                </div>\n                                <div class=\"c-grid-cars-big__prices__item\">\n                                    <div class=\"c-grid-cars__payment-time\">À partir de</div>\n                                    <div class=\"c-grid-cars__payment-amount\">\n                                        <span class=\"c-grid-cars__payment-amount__num\">{{cash(car.price)}}</span>\n                                    </div>\n                                </div>")
                  ])
                ])
              ])
            ], 8 /* PROPS */, _hoisted_28)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($props.type=='small')
      ? (_openBlock(), _createElementBlock("a", {
          key: 3,
          href: $props.car.permalink,
          class: "c-grid-cars__content"
        }, [
          _createElementVNode("h3", _hoisted_44, _toDisplayString($props.car.make) + " " + _toDisplayString($props.car.model), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_45, _toDisplayString($props.car.trim) + " " + _toDisplayString($props.car.year), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.nb($props.car.kms)) + " km", 1 /* TEXT */),
          ($props.car.payments)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, _toDisplayString($props.car.payments.type=='lease' ? 'Location' :
                    'Financement') + " " + _toDisplayString($props.car.payments.term) + " mois", 1 /* TEXT */),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.cents($props.car.payments.weekly)), 1 /* TEXT */),
                  _cache[13] || (_cache[13] = _createTextVNode()),
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "-grid-cars-color-alt" }, "/sem", -1 /* HOISTED */))
                ]),
                ($props.car.payments && $props.car.payments.rebate)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["c-grid-cars__price-tag", {'-centered': $props.car.rebate == $props.car.payments.rebate, '-normal':  $props.car.rebate != $props.car.payments.rebate}])
                    }, " - " + _toDisplayString(_ctx.cash($props.car.payments.rebate)), 3 /* TEXT, CLASS */))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              ($props.car.rebate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.cash($props.car.price+$props.car.rebate)), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("span", null, _toDisplayString(_ctx.cash($props.car.price)), 1 /* TEXT */)
              ])
            ]),
            ($props.car.rebate && (!$props.car.payments || $props.car.payments.rebate != $props.car.rebate))
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, "- " + _toDisplayString(_ctx.cash($props.car.rebate)), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_56, " Stock " + _toDisplayString($props.car.stocknumber) + " / NIV " + _toDisplayString($props.car.vin_short), 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_43))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}